<div *ngIf="loading">
  <deltacapita-content-loader></deltacapita-content-loader>
</div>
<div *ngIf="!loading">
  <div class="form-container">
    <form [formGroup]="uploadFileForm" (ngSubmit)="uploadFile()">
      <div id="distributor_doc" [hidden]="!currentRow.name">Document for "{{ currentRow.name }}"</div>

      <div class="form-group icon">
        <app-dc-select
          label="Distributor"
          [labelId]="'distributor'"
          [placeholder]="'Select distributor'"
          [items]="distributorsDropdownData"
          [checkbox]="false"
          formControlName="distributor"
          [disabled]="false"
          [multiple]="false"
          [searchable]="true"
          [closeOnSelect]="true"
          [readonly]="false"
          [hidden]="currentRow.name"
        ></app-dc-select>
      </div>

      <div class="form-group">
        <app-dc-input
          formControlName="title"
          [id]="'title'"
          [label]="'Title'"
          [type]="'text'"
          [readonly]="false"
          placeholder="Please give this file a title"
        ></app-dc-input>
      </div>

      <div class="form-group">
        <app-dc-input
          formControlName="userTag"
          [id]="'userTag'"
          [label]="'User Tag'"
          [type]="'text'"
          [readonly]="false"
          placeholder="Please tag this file with a user message (optional)"
        ></app-dc-input>
      </div>

      <div class="form-group">
        <app-dc-checkbox
          [id]="'checkbox1'"
          formControlName="forAll"
          label="Share with All connected Issuers, including future requesters"
        ></app-dc-checkbox>
      </div>

      <div class="form-group icon">
        <label>Please choose who can access this file:</label>
        <div *ngFor="let issuer of requesters" style="margin: 0 5px">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              [value]="issuer.issuerID"
              [id]="defaultCheck1 + i"
              (change)="onIssuerCheckboxChange($event)"
              [disabled]="isForAllChecked"
              [checked]="uploadFileForm.get('issuers').value.includes(issuer.issuerID)"
            />
            <label class="form-check-label" [for]="defaultCheck1 + i">
              {{ issuer.issuerName }}
            </label>
          </div>
          <!-- <label>
            <input
              type="checkbox"
              [value]="issuer.issuerID"
              (change)="onIssuerCheckboxChange($event)"
              [disabled]="isForAllChecked"
            />

            {{ issuer.issuerName }}
          </label> -->
        </div>
      </div>

      <div class="form-group icon">
        <div>Which types of available requests you would like to attach this file:</div>
        <div style="display: flex; flex-flow: row-wrap">
          <div *ngFor="let type of availableTypes; index as i" style="margin: 0 15px">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [value]="type.requestid"
                [id]="defaultCheck2 + i"
                (change)="onRequestTypesCheckboxChange($event)"
                [checked]="uploadFileForm.get('types').value.includes(type.requestid)"
              />
              <label class="form-check-label" [for]="defaultCheck2 + i">
                {{ type.type === 'KYD' ? 'KYD - ' + type.template : type.template ? type.template : type.type }}
              </label>
            </div>
            <!-- <label>
              <input type="checkbox" [value]="type.requestid" (change)="onRequestTypesCheckboxChange($event)" />

              {{ type.type }}
            </label> -->
          </div>
        </div>
      </div>

      <div class="form-group icon">
        <app-dc-checkbox
          formControlName="emailCheckbox"
          label="Send Notification Emails to Issuer Contacts (with active connections)"
        ></app-dc-checkbox>
      </div>

      <div class="text-center">
        <button class="btn btn-outline-primary">
          <input type="file" class="file-input" id="fileInput" (change)="onFileSelected($event)" #fileUpload />
        </button>
      </div>
      <br />

      <div class="submit-btn text-center pt-3 pb-3">
        <button class="btn btn-primary" type="submit" [disabled]="!uploadFileForm.valid || !fileName || !fileType">
          Upload
        </button>
      </div>
    </form>
  </div>
</div>
